import React, { memo } from "react";

import { Flex, IFlexProps } from "../Flex";

export const RowBase: React.FC<
  Omit<IFlexProps, "direction"> & React.RefAttributes<HTMLDivElement>
> = (props) => {
  return (
    <Flex
      {...props}
      // HACK: Row shouldn't accept direction, but it's passed by builder.io and possibly other sources. Support it for now.
      direction={(props as unknown as IFlexProps).direction ?? "row"}
    />
  );
};

/**
 * @trackcomponent
 */
export const Row = memo(RowBase);
